import type { User } from '../types/user';

export function checkUserRight(user: User, right: number): boolean {
  return user.permissions.includes(right);
}
